import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatDate } from './formatDate';

interface PatientTemplateProps {
  patientName: string;
  birthDate?: string;
}

/**
 * Patient name and DOB template
 */
export const PatientTemplate: React.FC<PatientTemplateProps> = ({ patientName, birthDate }) => (
  <Box>
    <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.875rem', lineHeight: 1.2 }}>
      {patientName}
    </Typography>
    <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem' }}>
      DOB: {formatDate(birthDate)}
    </Typography>
  </Box>
);

export default PatientTemplate;
